/** @format */
// The `<course-unit-info-section>` AngularJS directive that used to live alongside this module has
// been deleted (zero element consumers anywhere). This file persists only because
// `app/plan/plan.module.js` (PLAN-VIEW) declares `'student.common.components.module-info.modal'` as
// a module dependency — the empty shell keeps that AngularJS bootstrap resolving. It folds away
// with Tier F.
import angular from 'angular';
angular.module('student.common.components.module-info.modal', []);